import axios from 'axios'

export default {
    getOverview(fromDate, toDate) {
        return axios.get('/intelligence/overview', {
            params: {
                fromDate,
                toDate,
            },
        })
    },

    getConstraints(fromDate, toDate) {
        return axios.get('/intelligence/constraints', {
            params: {
                fromDate,
                toDate,
            },
        })
    },
}
